"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BridgeSync;
var _react = require("react");
var _AssistantProvider = require("./AssistantProvider");
function BridgeSync(_ref) {
  let {
    goldenId,
    pageName,
    updatePageContext
  } = _ref;
  const {
    setGoldenId,
    setUpdatePageContext
  } = (0, _AssistantProvider.useAssistant)();
  (0, _react.useEffect)(() => {
    if (goldenId !== undefined) {
      setGoldenId(goldenId);
    }
  }, [goldenId, setGoldenId]);
  (0, _react.useEffect)(() => {
    if (updatePageContext) {
      setUpdatePageContext(() => updatePageContext);
    }
  }, [updatePageContext, setUpdatePageContext]);
  return null;
}